import React from "react";
import "./SwiperMainCard.scss";

interface SwiperMainCardProps {
  title: string;
  image: string;
  span: string;
  header: string;
}

const SwiperMainCard: React.FC<SwiperMainCardProps> = ({
  title,
  image,
  span,
  header,
}) => {
  return (
    <div className="swiper-main-card-wrapper">
      {header && (
        <div className="header">
          <p className="header-text">{header}</p>
        </div>
      )}
      <p className="section-main-header white second-header">
        <span>{span}</span> {title}
      </p>
      <img
        src={image}
        alt={title ? `${title} banner` : span ? `${span} banner` : "Swiper main image"}
        className="swiper-main-card-image"
      />
    </div>
  );
};

export default SwiperMainCard;
